<template>
    <div class="sales-land-page" v-if="salesCard != null && setup != null">
        <navLand></navLand>
        <promoLand :cityProject="CityProject"></promoLand>
        <mainLand></mainLand>
        <aboutLand v-if="salesCard.project_land_site.about_init == 'true'" id="land-about"></aboutLand>
        <locationLand v-if="salesCard.project_land_site.location_init == 'true'" id="land-location"></locationLand>
        <premsLand v-if="salesCard.project_land_site.prems_init == 'true'" id="land-prems"></premsLand>
        <formLand :promoForm="CityProjectSales" v-if="formInit"></formLand>
        <flatsLand v-if="salesCard.project_land_site.flats_init == 'true' && flatsInit == true" id="land-flats"></flatsLand>
        <galleryLand v-if="salesCard.project_land_site.gallery_init == 'true'" id="land-gallery"></galleryLand>
        <newsLand v-if="salesCard.project_land_site.news_init == 'true'" id="land-news"></newsLand>
        <formLand :promoForm="CityProject" v-if="formInit && contactsSetup && salesCard.project_land_site.contacts_init == 'true'"></formLand>
        <contactsLand :cityProject="CityProject" v-if="CityProject != null && setup != null && contactsSetup && salesCard.project_land_site.contacts_init == 'true'" id="land-contacts"></contactsLand>
        <div class="container">
            <sharePostBottom :options="[{title: 'Поделиться ' + CapitalizeID(cardID) +  ':', data_title: CapitalizeID(cardID) + ' - ' + salesCard.project_title, data_link: 'https://sales.bazis.kz/sales/' + cardID, data_page: 'Sales_Land - ' + CapitalizeID(cardID), data_page_key: 'sales-land-page'}]"></sharePostBottom>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    import navLand from '@/components/sales/sales-land-partials/land-nav.vue'
    import promoLand from '@/components/sales/sales-land-partials/land-promo.vue'
    import mainLand from '@/components/sales/sales-land-partials/land-main.vue'
    import aboutLand from '@/components/sales/sales-land-partials/land-about.vue'
    import locationLand from '@/components/sales/sales-land-partials/land-location.vue'
    import premsLand from '@/components/sales/sales-land-partials/land-prems.vue'
    import flatsLand from '@/components/sales/sales-land-partials/land-flats.vue'
    import galleryLand from '@/components/sales/sales-land-partials/land-gallery.vue'
    import newsLand from '@/components/sales/sales-land-partials/land-news.vue'
    import contactsLand from '@/components/sales/sales-land-partials/land-contacts.vue'
    import formLand from '@/components/forms/form-sales-land.vue'
    import sharePostBottom from '@/components/share/share-social-bottom.vue'

    export default {
        name: 'sale-land-page',
        components: {
            navLand,
            promoLand,
            mainLand,
            aboutLand,
            locationLand,
            premsLand,
            flatsLand,
            galleryLand,
            newsLand,
            contactsLand,
            formLand,
            sharePostBottom,
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                cardID: this.$route.params.id,
                CityProject: null,
                CityProjectSales: null,
                formInit: false,
                flatsInit: false,
                swiperOption: {
                    speed: 800,
                    loop: true,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    slidesPerView: 1,
                    simulateTouch: false,
                    watchSlidesVisibility: true,
                    lazy: {
                        loadPrevNext: true,
                        loadOnTransitionStart: true
                    },
                    autoplay: {
                        delay: 3500,
                        disableOnInteraction: true,
                    },
                },
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            setup: 'loadPageSetUp',
            contactsSetup: 'loadContactsPage',
        }),
        methods: {
            filterRegion() {
                if (this.setup != null) {
                    var data = this.setup.regions_name;
                    var filteredItems = data.filter(item => {
                        return item.region_lat.slug === this.salesCard.city_name.slug
                    });
                    this.CityProject = filteredItems[0];
                    this.formInit = true;
                    // console.log(this.CityProject)
                }
                // console.log(this.setup)
                
                // this.$store.commit('CurrentCityArr', filteredItems);
                // this.regionCityArr = filteredItems;
            },
            filterRegionSales() {
                if (this.setup != null) {
                    var data = this.setup.regions_name;
                    var filteredItems = data.filter(item => {
                        return item.region_lat.slug === this.salesCard.city_name_sales.slug
                    });
                    this.CityProjectSales = filteredItems[0];
                    this.formInit = true;
                    // console.log(this.CityProject)
                }
                // console.log(this.setup)
                
                // this.$store.commit('CurrentCityArr', filteredItems);
                // this.regionCityArr = filteredItems;
            },
            CapitalizeID(s) {
                if (typeof s !== 'string') return ''
                return s.charAt(0).toUpperCase() + s.slice(1)
            },
            getFlatsData() {
                axios.get('https://flats.bazis.kz/cms/' + window.GlobalLang + '/wp-json/wp/v2/' + this.cardID + '/?per_page=100').then(async (response) => {
                    // console.log(response, 'FLATS')
                    this.$store.commit('salesCardContentFlats', response.data);
                    this.flatsInit = true;
                });
            }
        },
        beforeCreate() {
            this.$store.dispatch('getContactsPageData');
        },
        created () {
            // this.getDataCard();
            document.body.dataset.page = 'sales-land-page';
        },
        mounted () {
            this.filterRegion();
            this.filterRegionSales();
            this.getFlatsData();
            this.$store.watch(
                (state) => state.pageSetup,
                (newValue) => {
                    // console.log('setup')
                    this.filterRegion();
                    this.filterRegionSales();
                }
            );
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>